<!-- No rows -->
<div
  fxLayout="column" fxLayoutAlign="center center"
  class="gd-list-table-data-no-rows">

  <!-- Image -->
  <div
    class="gd-list-table-data-no-rows-image"></div>

  <!-- Message -->
  <div
    class="gd-list-table-data-no-rows-text">{{'LNG_COMMON_LABEL_EMPTY_TABLE' | translate}}</div>
</div>
